import React from 'react';

export function ImpactBadge({ level }: { level: string | null }) {
  if (!level) return null;
  const cls =
    level === 'high' ? 'impact-badge--high' :
    level === 'medium' ? 'impact-badge--medium' :
    'impact-badge--low';
  return <span className={`impact-badge ${cls}`}>{level.toUpperCase()}</span>;
}

export function DocTypeBadge({ type }: { type: string | null }) {
  if (!type) return null;
  return <span className="doc-type-badge">{type}</span>;
}

export function getClassificationInfo(classification: string | null): { label: string; className: string } {
  if (!classification) return { label: 'Unknown', className: 'rasff-badge--default' };
  const cl = classification.toLowerCase();
  if (cl.includes('alert'))            return { label: 'Alert',            className: 'rasff-badge--alert' };
  if (cl.includes('border rejection')) return { label: 'Border Rejection', className: 'rasff-badge--border' };
  if (cl.includes('information') && cl.includes('attention'))
                                       return { label: 'Info (attention)', className: 'rasff-badge--info-att' };
  if (cl.includes('information'))      return { label: 'Info (follow-up)', className: 'rasff-badge--info' };
  if (cl.includes('non-compliance'))   return { label: 'Non-compliance',   className: 'rasff-badge--noncomp' };
  return { label: classification, className: 'rasff-badge--default' };
}

export function formatDDMMYYYY(dateStr: string | null | undefined): string {
  if (!dateStr) return '';
  const match = dateStr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return dateStr;
  const [, dd, mm, yyyy] = match;
  return new Date(Number(yyyy), Number(mm) - 1, Number(dd))
    .toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatISODate(dateStr: string | null): string {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return dateStr;
  }
}
